import { Link } from "react-router-dom";
import { ArrowRight, Check, Building2, Home, Warehouse, Building } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const types = [
  { icon: Building, t: "Apartments", d: "Studios to 3-bed & penthouses", img: "/images/coverage-apartment.webp", href: "/apartment-inspection-dubai", alt: "High-rise apartment tower in a Dubai canal district" },
  { icon: Home, t: "Villas", d: "Incl. external areas where safe & in scope", img: "https://images.pexels.com/photos/10647324/pexels-photo-10647324.jpeg?auto=compress&cs=tinysrgb&w=640", href: "/villa-inspection-dubai", alt: "Detached villa exterior in a Dubai community" },
  { icon: Building2, t: "Townhouses", d: "Multi-floor & new developments", img: "/images/coverage-townhouse.webp", href: "/property-snagging-dubai", alt: "Premium Dubai residence living room with Burj Khalifa skyline view" },
  { icon: Warehouse, t: "Commercial", d: "Offices, retail & portfolios", img: "/images/coverage-commercial.webp", href: "/commercial-property-inspection-dubai", alt: "Modern glass office building with landscaped plaza in Dubai" },
];

export default function Coverage({ onQuote }) {
  return (
    <>
      <section id="property-types" className="py-20 lg:py-24 bg-white">
        <div className="wrap">
          <SectionHead eyebrow="Every property type" title="From studios to signature villas." sub="Whatever you're accepting, we have an inspection scope and report built for it." />
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {types.map(({ icon: Icon, t, d, img, href, alt }, i) => (
              <Reveal key={t} delay={(i % 4) * 0.05}>
                <Link to={href} data-testid={`type-${t.toLowerCase()}`}
                  className="group block border border-line rounded-[14px] bg-white h-full overflow-hidden hover:border-blue transition-colors">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={img} alt={alt} width={640} height={400} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="p-5">
                    <Icon size={20} className="text-blue mb-2" />
                    <h3 className="text-[1.08rem] mb-1">{t}</h3>
                    <p className="text-muted text-[0.83rem]">{d}</p>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Overseas band */}
      <section className="py-20 lg:py-24 bg-soft border-y border-line">
        <div className="wrap">
          <Reveal>
            <div className="rounded-[20px] border border-line p-10 lg:p-14 grid lg:grid-cols-[1.35fr_.65fr] gap-11 items-center relative overflow-hidden bg-white">
              <div className="relative z-10">
                <span className="eyebrow">For overseas buyers</span>
                <h2 className="text-[clamp(1.7rem,3.2vw,2.4rem)] mt-3 mb-4">Buying UAE property from abroad? We can be your eyes on the ground.</h2>
                <p className="text-muted mb-7 max-w-[46ch]">Fedari Inspection can inspect the property while you're overseas and deliver everything digitally — so distance never means uncertainty.</p>
                <Link to="/services/overseas-property-inspection-dubai" className="inline-flex items-center gap-2 bg-blue text-white px-6 py-3.5 rounded-[10px] font-semibold hover:bg-blue-600 transition-colors" data-testid="overseas-link">
                  Overseas property inspection <ArrowRight size={16} />
                </Link>
              </div>
              <ul className="flex flex-col gap-3 relative z-10">
                {["Professional on-site inspection", "Photographic documentation of relevant visible findings", "Detailed digital report", "Clear finding descriptions", "Remote communication"].map((t) => (
                  <li key={t} className="flex gap-2.5 items-center text-bodytext font-medium text-[0.92rem]"><Check size={18} className="text-blue flex-none" /> {t}</li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
